<template>
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="bank_card_box">
      <div class="left">
        <leftTemplate :left_tabShow="'bank_card'"></leftTemplate>
      </div>
      <div class="right">
        <div class="add_bank_card_box">
          <div class="add_bank_card" @click="handleCard">添加银行卡</div>
        </div>
        <div class="bank_card_item_box">
          <div class="bank_card_item" v-for="(item, index) in list">
            <div class="bank_card_item_img">
              <img :src="require('@/assets/bankCard/zx.png')" v-if="item.bankName == '中信银行'" />
              <img :src="require('@/assets/bankCard/zg.png')" v-else-if="item.bankName == '中国银行'" />
              <img :src="require('@/assets/bankCard/zs.png')" v-else-if="item.bankName == '招商银行'" />
              <img :src="require('@/assets/bankCard/cx.png')" v-else-if="item.bankName == '储蓄银行'" />
              <img src="@/assets/bankCard/xy.png" v-else-if="item.bankName == '兴业银行'" />
              <img src="@/assets/bankCard/qs.png" v-else-if="item.bankName == '齐商银行'" />
              <img src="@/assets/bankCard/pf.png" v-else-if="item.bankName == '浦发银行'" />
              <img src="@/assets/bankCard/ny.png" v-else-if="item.bankName == '农业银行'" />
              <img src="@/assets/bankCard/jt.png" v-else-if="item.bankName == '交通银行'" />
              <img src="@/assets/bankCard/js.png" v-else-if="item.bankName == '建设银行'" />
              <img src="@/assets/bankCard/ws.png" v-else-if="item.bankName == '微商银行'" />
              <img src="@/assets/bankCard/hx.png" v-else-if="item.bankName == '华夏银行'" />
              <img src="@/assets/bankCard/ncxys.png" v-else-if="item.bankName == '农村信用社银行'" />
              <img src="@/assets/bankCard/gd.png" v-else-if="item.bankName == '光大银行'" />
              <img src="@/assets/bankCard/gs.png" v-else-if="item.bankName == '工商银行'" />
              <img src="@/assets/bankCard/dy.png" v-else-if="item.bankName == '东亚银行'" />
              <img src="@/assets/bankCard/hq.png" v-else-if="item.bankName == '华侨银行'" />
              <img src="@/assets/bankCard/zgpa.png" v-else-if="item.bankName == '中国平安银行'" />
              <img src="@/assets/bankCard/ms.png" v-else-if="item.bankName == '民生银行'" />
              <img src="@/assets/bankCard/qt.png" v-else-if="item.bankName == '其他'" />
            </div>
            <div class="bank_card_item_right">
              <div style="
                  margin: 0.02rem 0 0.12rem;
                  color: #333333;
                  font-size: 0.16rem;
                  display: flex;
                  justify-content: space-between;
                ">
                <span>{{ item.bankName }}</span>
                <span style="color: #C01A26; font-size: 0.14rem; cursor: pointer"
                  @click="bankCardDel(item.id)">解除绑定</span>
              </div>
              <div style="
                  margin: 0.02rem 0 0.12rem;
                  color: #333333;
                  font-size: 0.12rem;
                ">
                {{
                  item.bankType == "DEBITCARD"
                  ? "储蓄卡"
                  : item.bankType == "CREDITCARD"
                    ? "信用卡"
                    : item.bankType == "ALIPAY"
                      ? "支付宝"
                      : item.bankType == "WECHAT"
                        ? "微信"
                        : ""
                }}
              </div>
              <div style="color: #333333; font-size: 0.18rem; font-weight: bold">
                {{ item.bankNo }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 去认证 -->
    <el-dialog title="" v-model="addAuthenVisible" align-center width="480px" :close-on-click-modal="false">
      <gotoAuthentication></gotoAuthentication>
    </el-dialog>
    <!-- 添加银行卡 -->
    <el-dialog title="添加银行卡" v-model="addCardVisible" align-center width="480px" :before-close="handleCloseCard"
      :close-on-click-modal="false">
      <bacnk-card-add ref="bacnkCardAddRef" @submit="onSubmit"></bacnk-card-add>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate from "@/components/leftTemplate.vue";
import bacnkCardAdd from "@/components/card/bacnk_card_add.vue";
import gotoAuthentication from "@/components/card/gotoAuthentication.vue";
import { ref, nextTick } from "vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRouter } from "vue-router";
document.title = "标识山西-我的银行卡";
import { ElMessage, ElMessageBox } from "element-plus";
let allCheckbox = ref(false);
const router = useRouter();

//添加银行
let addCardVisible = ref(false);
const bacnkCardAddRef = ref();
const handleCard = async () => {
  Axios("get", `/member/login-info`, {}, false, async (res) => {
    let data = res.data.data;
    if (data.realStatus == 0) {
      ElMessageBox.confirm(
        '您还未进行实名认证，请先实名认证',
        '',
        {
          confirmButtonText: '前往认证',
          cancelButtonText: '取消',
          type: 'error',
          customClass: 'bank_card',
          center: true,
        }
      )
        .then(() => {
          router.push({
            path: "/AuthenTication",
            query: { num: 3 }
          });
        }).catch(() => {

        })
      return
    } else if (data.realStatus == 1) {
      ElMessage.error("认证状态：审核中");
      return
    } else if (data.realStatus == 2) {
      addCardVisible.value = true;
      await nextTick();
      bacnkCardAddRef.value.init();

      if (!router.currentRoute.value.query.showDialog) {
        router.push({
          query: {},
          replace: true,
        });
      }
    } else {
      ElMessage.error("认证状态：认证失败");
      return
    }
  });

};
const handleCloseCard = () => {
  if (router.currentRoute.value.query.showDialog) {
    router.replace({
      path: "/requirementManagement", // replace with your actual route
      query: {
        state: "first",
      },
    });
  }
  addCardVisible.value = false;
};
//认证
let addAuthenVisible = ref(false);
const handleAuthen = () => {
  addAuthenVisible.value = true;
};
//我的银行卡
const list = ref([]);
const init = () => {
  Axios("get", "/member/member-bank/my-list", false, false, (res) => {
    console.log(res);
    list.value = res.data.data;
    if (router.currentRoute.value.query.showDialog) {
      handleCard();
    }
  });
};
init();
const onSubmit = () => {
  addCardVisible.value = false;
  console.log(
    "router.currentRoute.value.query.showDialog",
    router.currentRoute.value.query.showDialog
  );

  if (router.currentRoute.value.query.showDialog) {
    handleCloseCard();
  }
  init();
};
//解除绑订

const bankCardDel = (id) => {
  Axios("delete", `/member/member-bank/${id}`, false, false, (res) => {
    ElMessage({
      message: "解除成功",
      type: "warning",
    });
    init();
  });
};
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);

.bank_card_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
}

.bank_card_item_box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 0.1rem;
  box-sizing: border-box;
}

.bank_card_item {
  width: calc(33.333% - 0.2rem);
  /* height: 1.11rem; */
  border-radius: 0.12rem;
  opacity: 1;
  margin: 0.1rem;
  padding: 0.16rem;
  border: 0.01rem solid #e5e6eb;
  box-sizing: border-box;
  display: flex;
}

.bank_card_item_img {
  background: #ccc;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  margin-right: 0.12rem;
}

.bank_card_item_img img {
  width: 0.4rem;
  height: 0.4rem;
}

.bank_card_item_right {
  width: calc(100% - 0.4rem - 0.16rem - 0.16rem);
}

.add_bank_card_box {
  padding: 0.12rem 0.16rem;
  border-bottom: 1px solid #e5e6eb;
  margin-bottom: 0.1rem;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

.add_bank_card {
  width: 1.02rem;
  height: 0.37rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  line-height: 0.37rem;
  color: #fff;
  cursor: pointer;
}
</style>
<style lang="less">
.bank_card .el-message-box__title {
  font-size: 60px !important;
  padding-left: 25px !important;
}

.bank_card {
  border-radius: 12px !important;
}

.bank_card .el-message-box__btns {
  button {
    width: 88px !important;
    line-height: 32px !important;
    text-align: center;
    line-height: 32px;
  }
}
</style>